import { RootState } from "../../utils/types"

export const UserLoginResponseSelector = (state: RootState) => 
  state.login  
  